export default {
    name: 'Bag',
    dimensions: { width: 21, height: 24 },
    content: `
    <g fill="none" clip-path="url(#clip0_4043_30)">
        <path d="M19.2051 23H13.2051L15.2051 7H17.2051L19.2051 23Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.2051 7L13.2051 23H1.20508L3.20508 7H15.2051Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.2051 1C8.54508 1 7.20508 2.34 7.20508 4V7H13.2051V4C13.2051 2.34 11.8651 1 10.2051 1Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_4043_30">
            <rect width="20" height="24" fill="currentColor" transform="translate(0.205078)"/>
        </clipPath>
    </defs>
  `
};
